<script setup lang="ts"></script>

<template>
  <CareersSection :title="$t('careers.steps.title')" :eyebrow="$t('careers.steps.eyebrow')" section-id="steps-section">
    <ul
      class="grid grid-cols-1 flex-col items-center gap-4 sm:grid-cols-2 md:grid-cols-3 md:px-8 lg:flex lg:flex-row lg:items-start lg:justify-center lg:gap-8 lg:px-16 xl:px-0"
    >
      <CareersStep
        v-for="index of 6"
        :key="index"
        :number="index"
        :title="$t(`careers.steps.items.${index}.title`)"
        :comment="$t(`careers.steps.items.${index}.comment`)"
        class="line"
      />
    </ul>
  </CareersSection>
</template>

<style scoped>
@media screen(lg) {
  .line::before {
    content: '';
    position: absolute;
    top: 72px;
    left: -100px;
    width: 170px;
    height: 2px;
    background: #a9e7e2;
    z-index: -1;
  }

  .line:first-child::before {
    display: none;
  }
}
</style>
